var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-input-group',[_c('b-input-group-prepend',[_c('b-button',{attrs:{"variant":"danger"},on:{"click":_vm.clear}},[_c('font-awesome-icon',{attrs:{"icon":"times"}})],1)],1),_c('b-input',{attrs:{"placeholder":_vm.$t('global.suche')},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }